export default __webpack_public_path__ + "static/media/tutorHero.fd7610cd.svg";